module.exports = __webpack_public_path__ + "img/learn.a5d77d56.png";